module.exports = "<div class=welcome> <h2>欢迎您使用猛犸电动社区管理系统！</h2> <br><small>选择左侧菜单进行管理</small> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/components/page/welcome/welcome.tpl
// module id = 933
// module chunks = 2